// Custom Accordion
$(document).ready(function() {
    $(".accordion-list").on("click", ".faq-accoitem .title", function() {
        var $accordionItem = $(this).parent(); // Clicked item ka parent (faq-accoitem)
        var $accordionList = $(this).closest('.accordion-list'); // Accordion list container

        // Toggle active class
        if ($accordionItem.hasClass('active')) {
            $accordionItem.removeClass('active');
        } else {
            $accordionList.find('.faq-accoitem').removeClass('active');
            $accordionItem.addClass('active');
        }
    });
});

// End custom Accordion

// Add has-inner-banner class to the body if .inner-banner class exists
document.addEventListener('DOMContentLoaded', function() {
  var innerBanner = document.querySelector('.common-inner-banner');
  if (innerBanner) {
    document.body.classList.add('has-inner-banner');
  }
});


